export default __webpack_public_path__ + "static/media/portfolio-124.3135dfbc.jpg";